<template>
    <PopoverRight ref="popoverMenu" width="600px">
        <div class="popover-slider-bar">
            <h1 class="bar-title">编辑页面TDK</h1>
            <p class="remark">1、动态取值字段请用[标签名]表示，如[城市] 在长沙站生成TDK内容时展示为：长沙，广州站生成时展示为：广州。</p>
            <p class="remark">2、支持动态取值的字段名称及取值示范，可点击<span @click="showTagLib" style="color:rgb(0 85 245);cursor: pointer;">“动态取值标签库”</span>  进行查看。</p>
            <el-form class="form-container" :model="formInfo" :rules="infoRules" ref="infoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">页面名称</span>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="contacts">
                            {{formInfo.page_name}}
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">标题</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="title">
                            <el-input placeholder="不超过999个字符" v-model="formInfo.title">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">描述</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="description">
                            <el-input type="textarea" :rows="2" placeholder="不超过999个字符" v-model="formInfo.description">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">关键词</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="keywords">
                            <el-input placeholder="可添加多个关键词，关键词之间用','间隔" v-model="formInfo.keywords">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                    <el-button type="primary" v-preventReClick @click="submitForm('infoForm')">保 存</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>
<script>
    import PopoverRight from '@/components/popoverRight/index'
    import {getPageTdksDetail,editPageTdks} from '@/service/tdkManage'

    export default {
        components:{
            PopoverRight
        },
        props: {
            callback: Function,
        },
        data(){
            return {
                formInfo:{
                    title:"",
                    keywords:"",
                    description:"",
                    page_name:""
                },
                infoRules:{
                    title: [
                        { required: true, message:'标题不能为空', trigger: 'blur' },
                        { min:0,max:999,message:'不超过999字符',trigger: "blur"}
                    ],
                    description:[
                        { required: true, message:'描述不能为空', trigger: 'blur' },
                        { min:0,max:999,message:'不超过999字符',trigger: "blur"}
                    ],
                    keywords:[
                        { required: true, message:'关键词不能为空', trigger: 'blur'},
                        { min:0,max:999,message:'不超过999字符',trigger: "blur"}
                    ]
                
                },
            }
        },
        methods:{
            open(info) {
                getPageTdksDetail(info.id).then(res => {
                    this.formInfo = res
                    if(this.formInfo.page_type == 2){
                        this.formInfo.condition = this.formInfo.condition_page_url
                    }
                })
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide() {
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
                // this.resetForm()
                this.$refs.userInfoForm && this.$refs.userInfoForm.clearValidate()
            },
            submitForm(formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        editPageTdks(this.formInfo.id,this.formInfo).then((data) => {
                            this.$message({
                                message: '编辑成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.hide()
                            this.callback && this.callback();
                        }).catch(err => {
                            this.$message({
                                message: err.message || '编辑失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                    } else {

                        return false
                    }
                })
            },
            showTagLib(){
                this.$emit("showTagLib")
            }
        }
    }
</script>
<style scoped>
.remark{
    font-size: 14px;
    padding-top: 10px;
    line-height:30px;
    color: #666;
}
</style>